import { CompositeDecorator } from "draft-js";
import { createStrategy } from "./strategies";
import Link from "../EditorToolbar/Links/Link";
import Insert from "../EditorToolbar/FieldInserts/Insert";


const decorator = new CompositeDecorator([
    {
        strategy: createStrategy('LINK'),
        component: Link,
    },
    {
        strategy: createStrategy('FIELD_INSERT'),
        component: Insert
    }
]);


export default decorator;